export default [{ code: 'identity', name: '身份管理', icon: 'el-icon-s-home', parentKey: '', selfFlg: 'identity' }];
